import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import Header from "./Headers";
import DashboardContent from "./DashboardDetails";
import RightPanel from "./RightPanel";
import { API_URL } from "../../config/api";

const StudentDashboard = () => {
  const [userData, setUserData] = useState(null);
  const [userCourses, setUserCourses] = useState([]);
  const [courseCounts, setCourseCounts] = useState({
    total_schedules: 0,
    active_courses: 0,
    completed_courses: 0,
    upcoming_courses: 0
  });
  const [loading, setLoading] = useState(true);

  // Fetch current user & enrolled courses
  useEffect(() => {
    const fetchUserAndCourses = async () => {
      const token = localStorage.getItem("access_token");

      if (!token) {
        console.error("No access token found");
        setLoading(false);
        return;
      }

      try {
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        const [userRes, courseRes] = await Promise.all([
          axios.get(`${API_URL}/current_user`, { headers }),
          axios.get(`${API_URL}/enroll-course/my-courses`, { headers }),
        ]);

        setUserData(userRes.data);
        
        // ✅ Extract schedules array from API response
        setUserCourses(courseRes.data.schedules || []);
        
        // ✅ Extract course counts from API response
        setCourseCounts({
          total_schedules: courseRes.data.total_schedules || 0,
          active_courses: courseRes.data.active_courses || 0,
          completed_courses: courseRes.data.completed_courses || 0,
          upcoming_courses: courseRes.data.upcoming_courses || 0
        });
        
        // Debug log to verify data structure
        console.log("✅ User Data:", userRes.data);
        console.log("✅ User Courses (Schedules):", courseRes.data.schedules);
        console.log("✅ Course Counts:", {
          total: courseRes.data.total_schedules,
          active: courseRes.data.active_courses,
          completed: courseRes.data.completed_courses,
          upcoming: courseRes.data.upcoming_courses
        });
      } catch (error) {
        console.error("❌ Error fetching dashboard data:", error);
        setUserCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndCourses();
  }, []);

  // Loading UI
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto"></div>
        </div>
      </div>
    );
  }

  // No user data → login error
  if (!userData) {
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Unable to load user data. Please log in again.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-100 flex flex-col">
      {/* Header */}
      <Header userData={userData} />

      {/* Main Layout */}
      <div className="flex flex-1">
        {/* Sidebar */}
        <aside className="w-56 bg-white border-r border-neutral-200 flex-shrink-0">
          <Sidebar />
        </aside>

        {/* Content + Right Panel */}
        <main className="flex-1 flex gap-4 p-4">
          {/* Dashboard Main */}
          <section className="flex-1">
            <DashboardContent
              userData={userData}
              userCourses={userCourses}
              courseCounts={courseCounts}
            />
          </section>

          {/* Right Panel */}
          <aside className="w-72 flex-shrink-0">
            <RightPanel
              userData={userData}
              userCourses={userCourses}
              courseCounts={courseCounts}
            />
          </aside>
        </main>
      </div> 
    </div>
  );
};

export default StudentDashboard;